/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallace rule: for a 17-mer with 8 A/T and 9 G/C, Tm = 2×8 + 4×9 = 52 °C.`)
};

const es_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regla de Wallace: para un 17-mero con 8 A/T y 9 G/C, Tm = 2×8 + 4×9 = 52 °C.`)
};

const de_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallace-Regel: Für einen 17-mer mit 8 A/T und 9 G/C ist Tm = 2×8 + 4×9 = 52 °C.`)
};

const nl_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallace-regel: voor een 17-mer met 8 A/T en 9 G/C, Tm = 2×8 + 4×9 = 52 °C.`)
};

const fr_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règle de Wallace : pour un 17-mère avec 8 A/T et 9 G/C, Tm = 2×8 + 4×9 = 52 °C.`)
};

const it_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regola di Wallace: per un 17-mero con 8 A/T e 9 G/C, Tm = 2×8 + 4×9 = 52 °C.`)
};

const pt_br2_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regra de Wallace: para um oligo de 17 bases com 8 A/T e 9 G/C, Tm = 2×8 + 4×9 = 52 °C.`)
};

const pt_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regra de Wallace: para um oligonucleótido de 17 bases com 8 A/T e 9 G/C, Tm = 2×8 + 4×9 = 52 °C.`)
};

const ja_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallace法: A/T 8個、G/C 9個の17merの場合、Tm = 2×8 + 4×9 = 52℃。`)
};

const zh_tm_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallace 规则：对于含 8 个 A/T 和 9 个 G/C 的 17 聚体，Tm = 2×8 + 4×9 = 52 °C。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_ex2", locale)
	if (locale === "en") return en_tm_ex2(inputs)
	if (locale === "es") return es_tm_ex2(inputs)
	if (locale === "de") return de_tm_ex2(inputs)
	if (locale === "nl") return nl_tm_ex2(inputs)
	if (locale === "fr") return fr_tm_ex2(inputs)
	if (locale === "it") return it_tm_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_tm_ex2(inputs)
	if (locale === "pt") return pt_tm_ex2(inputs)
	if (locale === "ja") return ja_tm_ex2(inputs)
	return zh_tm_ex2(inputs)
};